namespace RedBullMOBILE360.ESim {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.ESim.EsimActivationCodeDialog')
    export class EsimActivationCodeDialog extends Serenity.EntityDialog<EsimActivationCodeRow, any> {
        protected getFormKey() { return EsimActivationCodeForm.formKey; }
        protected getIdProperty() { return EsimActivationCodeRow.idProperty; }
        protected getLocalTextPrefix() { return EsimActivationCodeRow.localTextPrefix; }
        protected getNameProperty() { return EsimActivationCodeRow.nameProperty; }
        protected getService() { return EsimActivationCodeService.baseUrl; }
        protected getDeletePermission() { return EsimActivationCodeRow.deletePermission; }
        protected getInsertPermission() { return EsimActivationCodeRow.insertPermission; }
        protected getUpdatePermission() { return EsimActivationCodeRow.updatePermission; }

        protected form = new EsimActivationCodeForm(this.idPrefix);
    }
}